function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "car_4");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "car_4"
}, /*#__PURE__*/React.createElement("line", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  x1: 2.43,
  y1: 33.94,
  x2: 7.03,
  y2: 33.94
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  cx: 48.03,
  cy: 42.13,
  rx: 4.08,
  ry: 3.85
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  cx: 13.89,
  cy: 42.13,
  rx: 4.08,
  ry: 3.85
}), /*#__PURE__*/React.createElement("line", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  x1: 17.97,
  y1: 42.13,
  x2: 43.94,
  y2: 42.13
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M52.11,42.13h5.73a2.82,2.82,0,0,0,2.95-2.66V31a2.09,2.09,0,0,0-2.19-2H34.45V19.24A1.22,1.22,0,0,0,33.23,18h-7.5a4.25,4.25,0,0,0-3.28,1.4l-2.28,2.77L14.55,29H28a1.44,1.44,0,0,0,1.59-1.23V23.42A1.44,1.44,0,0,0,28,22.19H20.14"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M14.55,29H5.82a3.4,3.4,0,0,0-3.39,3.4v7c0,1.47,1.47,2.66,3.28,2.66H9.8"
}));

var SvgCar4 = function SvgCar4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCar4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/car_4.cfd6e8c2.svg";
export { ForwardRef as ReactComponent };